import styled from 'styled-components';
import { ButtonLink } from '@womcorp/wom-miwom-ui-kit/dist/components/Button';

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  &:nth-last-child(2) {
    margin-bottom: 16px;
  }
`;

const ButtonLinkStyled = styled(ButtonLink)`
  && {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    justify-content: start;

    @media (min-width: 769px) {
      justify-content: center;
    }

    svg {
      margin-left: 14px;
      flex-shrink: 0;
      transform: rotate(270deg);
    }
  }
`;

export { ItemContainer, ButtonLinkStyled };
